import React from 'react';
// import sections
import Principal from '../components/sections/Presentation';
import Values from '../components/sections/Values';

const Home = () => {

  return (
    <>
      <Principal />
      <Values />
      {/* <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <About topDivider />
      <Cta split /> */}
    </>
  );
}

export default Home;